module.exports = "<span class=\"cartItemMessage--matchedPromotion-description\" ng-bind-html=\"$ctrl.inlineMessage.message.promotionDescription\"></span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cartitemmessages/matched-promotion.html
// module id = 138
// module chunks = 0 2